<template>
  <div class="public-content acc_generalLedger">
      <div class="acc_generalLedger__head">
        <div class="acc_flex_1" >
            <div class="acc_flex">
              <div class="f-18 bold">总账</div>
                <div class="ml20 head__filter">
                  <el-input size="small" placeholder="点击筛选" v-model="dateRange" style="width: 220px" readonly @focus="isShowFilter = true" ></el-input>
                  <!-- 筛选 -->
                  <transition name="el-zoom-in-top">
                    <GlFilter v-show="isShowFilter" @close="isShowFilter = false" @getForm = "getForm" @getPeriod = "getPeriod" />
                  </transition>
                </div>
            </div>
            	<!-- 打印-导出 -->
            <div >
              <el-button size="small" @click='handleButtonPrint(item.function)' v-for="item in buttonList"  :key='item.id'>
                {{item.name}}
              </el-button>
            </div>
        </div>
      </div>
      <!-- list -->
      <div class="mt30">
        <public-table  :table="tableData" @onHandlePaginationChange="handlePaginationChange">
            <template slot-scope="props" slot="name">
              <span :class="{ 'acc-link': props.scope.row.auxiliary == 1 }" @click="goDetail(props.scope.row)">
                {{ props.scope.row.name }}
              </span>
            </template>
            <template slot-scope="props" slot="debitMoney">
              {{ disposeMoney(props.scope.row.debitMoney)  }}
            </template>
            <template slot-scope="props" slot="creditorMoney">
              {{ disposeMoney(props.scope.row.creditorMoney)  }}
            </template>
            <template slot-scope="props" slot="remainingSum">
              {{ disposeMoney(props.scope.row.remainingSum)  }}
            </template>
            <template slot-scope="props" slot="debitCoin">
              {{ disposeMoney(props.scope.row.debitCoin)  }}
            </template>
            <template slot-scope="props" slot="creditorCoin">
              {{ disposeMoney(props.scope.row.creditorCoin)  }}
            </template>
            <template slot-scope="props" slot="remainingCoin">
              {{ disposeMoney(props.scope.row.remainingCoin)  }}
            </template>
        </public-table>
      </div>

      <!-- 打印 -->
      <Print :isShow="isShowPrint" :showCoverChoose="true" @close = "isShowPrint = false" @print = "handlePrint($event)"  />
  </div>
</template>
<script>
import GlFilter from "./com/gl_filter.vue"
import Print from "./com/print.vue"
import { getTotalAcc } from "@/api"
import publicTable from '@/components/publicTable'
import { getTotalAccH } from "./config/tableHead"
import { currencys } from "@/assets/utils/currencyFormat";
export default {
  components: {GlFilter,publicTable,Print},
  data() {
    return {
        isShowPrint: false,
        currencys,
        dateRange: "",
        isShowFilter: false,
        tableData: {
          id:"code",
          border: true,				// 是否带有纵向边框
          stripe: true,				// 是否带有斑马纹
          loading: false,				// 是否显示加载动画
          hasSelect: false,			// 是否显示多选
          hasOperation: false,		// 是否有操作功能
          hasContextmenu: false,		// 是否有右键功能
          hasShowSummary: false,		// 是否显示合计行
          hasShowPagination: true,	// 是否显示分页
          config: getTotalAccH(false),
				data: [],
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				},
        arraySpanMethod: this.arraySpanMethod,			// 自定义合并行
			},
      buttonList:[],         // 按钮组
      printParams: {},  // 打印数据
      printForm: {        // 打印参数
				data: {
					start: '',
					end: '',
					isTotal: false
				},
				url: '/createPDF/printTotalDetail',
				continuityUrl: '/createPDF/printTotalDetail'
			},
      form: {
        pageSize: 20,
        pageNo: 1
      }
    }
  },
  created() {
    this.getTable();
    this.getButtonAuthorize();
  },
  methods: {
    disposeMoney(val) {
      return currencys(val)
    },
    // 打印处理
    handlePrint(form) {
      let printParams = {
          cid: sessionStorage.cid,
          token: sessionStorage.token,
          ...this.form,
          ...form,
          start: this.printForm.data.start,
          end: this.printForm.data.end,
      }
      const router = this.$router.resolve({
          path: 'createPDF/printGeneralLedger',
          query: printParams
        })
      this.isShowPrint = false;
      window.open(this.$rootUrl + router.href, '_blank')
    },
     // 按钮点击处理
    handleButtonPrint(type) {
      switch(type) {
        case 'print':
          this.isShowPrint = true;
          //this.printTotalDetail('1');
          break;
        case 'dc':
          this.exportGeneralLedger()
          break;
        default:
          break;
      }
    },
    // 导出
    exportGeneralLedger() {
        let printParams = {
            cid: sessionStorage.cid,
				    token: sessionStorage.token,
            ...this.form,
            start: this.printForm.data.start,
            end: this.printForm.data.end,
        }
        const router = this.$router.resolve({
          path: 'export/exportGeneralLedger',
          query: printParams
        })
        window.open(this.$rootUrl + router.href, '_blank')
    },
    printTotalDetail (type) { // 打印
			this.printParams = Object.assign({}, this.printParams, this.printForm.data, {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
			})
			const router = this.$router.resolve({
				path: type === '1' ? this.printForm.url : this.printForm.continuityUrl,
				query: this.printParams
			})
			window.open(this.$rootUrl + router.href, '_blank')
		},
    goDetail(row) { // 跳转明细
      if(row.auxiliary != 1) return;
      this.$router.push({
        path: "/subsidiaryLedger",
        query: {
          start: this.form.start,
          end: this.form.end,
          subjectId: row.subjectId || row.id
        }
      })
    },
    // 获取打印导出导入按钮权限
    getButtonAuthorize() {
      const _ = this;
      let params={
        permissions:'ac:books:generalLedger:dc,ac:books:generalLedger:dy'
      }
        _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
          if(res && res.data.code == 1) {
            _.buttonList = res.data.data;
          }
        })
    },
    getPeriod(data) {
      this.dateRange = data.start.slice(0,4) + '-' + data.start.slice(4) + " 至 " + data.end.slice(0,4) + '-' + data.end.slice(4)
      this.printForm.data.start = data.start;
      this.printForm.data.end = data.end;
    },
    getForm(form) { // 获取筛选数据
      this.form = Object.assign({},this.form,form);
      if(form.currencyId) { // 此时需要显示二级表头
        this.tableData.config = getTotalAccH(true)
      }else {
        this.tableData.config = getTotalAccH(false)
      }
      this.isShowFilter = false;
      this.getTable();
    },
    async getTable() {
      const { data } = await getTotalAcc(this.form);
      if(data.code == 1) {
         let dataInfo = data.data;
         let datas = dataInfo.list;
         let arr = [] , num = 0 , id = datas.length&&datas[0].id;
         this.tableData.page.count = parseInt(dataInfo.total);
         let dataList = dataInfo.list.map((item,index)=>{
						if(item.id == id) {
							arr.push(item);
						}else {
							arr = [],
							arr.push(item);
							num = index;
							id = datas[num].id;
						}
						datas[num].rows=arr.length;
						return item;
					})
         this.tableData.data = dataList;
      }

    },
    // 翻页
		handlePaginationChange (data) {
			const { pageNo, pageSize } = data;

			if (pageNo) {
				this.$set(this.form, 'pageNo', pageNo);
				this.$set(this.tableData.page, 'pageNo', pageNo);
			}

			if (pageSize) {
				this.$set(this.form, 'pageSize', pageSize);
				this.$set(this.tableData.page, 'pageSize', pageSize);
			}
			this.getTable();
		},
    // 合并
		arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (columnIndex < 2) {
				if (row.rows) {
					return {
						rowspan: row.rows,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		},
  }
}
</script>
<style lang="less" scoped>
.acc_generalLedger {
  &__head {
    .head__filter {
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/accountBook/generalLedger.vue